<template>
  <div>
    <editor
      name="description"
      api-key="f9tg25pq47z4zweve160g3wt475r0oycir62ddltkzsd8v6w"
      :init="{
        selector: 'textarea',
        height: 350,
        menubar: 'file edit insert view format table tools help',
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount toc'
        ],
        toolbar:
          'undo redo | formatselect | bold italic underline code backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help | toc'
      }"
      v-model="data"
      :initial-value="value"
    />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
export default {
  components: {
    editor: Editor
  },
  data() {
    return {
      data: ''
    }
  },
  props: ['value'],
  watch: {
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
    }
  }
}
</script>

<style lang="scss" scoped></style>
